<template>
  <div class="h-screen bg-access_point-300 flex flex-col container">
    <HeaderHome
      title="ACCESS POINT"
      sub-title="seguro e fácil"
      :userName="store.user?.name"
      :showModalLogout="showModal"
    />
    <div
      class="flex items-center w-full flex-col bg-white absolute bottom-0 container_footer"
    >
      <SelectRooms />
    </div>
    <img src="@/assets/background_image.png" class="img_home z-1 w-full" />
  </div>
  <ModalLogout ref="modalRef" />
</template>

<script lang="ts">
import HeaderHome from '@/components/Header/HeaderHome.vue';
import ModalLogout from '@/components/ModalLogout.vue';
import SelectRooms from '@/components/SelectRooms.vue';

import { useAuthStore } from '@/stores/AuthStore';
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'HomeView',
  components: { HeaderHome, SelectRooms, ModalLogout },
  data() {
    return {
      store: useAuthStore(),
    };
  },
  setup() {
    const modalRef = ref<InstanceType<typeof ModalLogout> | null>(null);
    const showModal = () => {
      if (modalRef.value) modalRef.value.openModal();
    };

    return { modalRef, showModal };
  },
});
</script>

<style>
:root {
  --custom-height_home: 85%;
}
.container {
  position: relative;
  width: 100%;
  height: 100vh;

  @media (min-width: 1200px) {
    width: 450px;
  }
}

.container_footer {
  height: var(--custom-height_home);
}

.img_home {
  position: absolute;
  left: 50%;
  transform: translate(-50%);

  @media (min-width: 576px) {
    bottom: calc(var(--custom-height_home) - 100px);
  }

  @media (max-width: 576px) {
    bottom: calc(var(--custom-height_home) - 57px);
  }
}
</style>
